module.exports = {
	"articleTitle1": "M Den provides preview of Nike product launch ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "The M-Den",
	"articleLink2": "https://www.michigandaily.com/section/news/jim-harbaugh-sign-autographs-mden",
	"articleSnippet1": "Jul 20, 2016 ... Pay a visit to the M Den website and you'll be greeted with a countdown clock to \nAug. 1, the first day Michigan's apparel contract with Nike ...",
	"articleSnippet2": "Feb 18, 2016 ... From 3 to 4:30 p.m., Harbaugh will be signing autographs at The M Den on State \nStreet. Wait so Harbaugh is gonna be at MDEN doing a ...",
	"totalMisc": 1,
	"articleTitle2": "Jim Harbaugh to sign autographs at M Den ",
	"address": "303 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://magnify.michigandaily.us/best_of_ann_arbor_2017/images/jwy.NEW.BOAABivuocandMDen.4.1.17.010.jpg",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279183,
		"lng": -83.740634
	},
	"tips": [
		{
			"text": "The stuff here is pretty damn expensive, but the clothes are still really cool.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/sports/m-den-provides-preview-nike-product-launch",
	"categories": {
		"clothingstore": 1,
		"bestofaa": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mden.json
// module id = 917
// module chunks = 0